import React from 'react';
import { observer } from 'mobx-react';
import { Company, ICompanyProps } from '../../Company';

export const BillingCompany: React.FC<ICompanyProps> = observer(({ isMe, isEdit, isNew }: ICompanyProps) => {
    return <Company isEdit={isEdit} isMe={isMe} isNew={isNew} />;
});
